/* eslint-disable */
import React from 'react';
import SelectionOverlay from './SelectionOverlay'
import {
  Text,
  StyleSheet,
  View,
  TouchableWithoutFeedback,
  Picker,
  TouchableHighlight,
} from 'react-native'

const styles = StyleSheet.create({
  overlay: {
    alignItems: 'center',
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    backgroundColor: 'white',
    zIndex: 11,
  },
})

export default class LanguageOverlay extends React.Component {
  constructor(props) {
    super(props)
    
    this.state = {
      original: '',
      translated: '',
      selectionType: 'original',
    }
  }
  
  onSelect(type, value) {
    this.setState({
      [type]: value,
      selectionType: 'translated',
    })
    
    if (type == 'translated') {
      this.props.emit('languageSelection', {
        original: this.state.original,
        translated: value,
      })
      
      this.onClose()
    }
  }
  
  getOptions(type) {
    let languages
    
    if (type == 'original') languages = Object.keys(this.props.availableLanguagePairs)
    if (type == 'translated') languages = this.props.availableLanguagePairs[this.state.original]
    
    return languages.map(language => ({
      label: language,
      value: language
    }))
  }
  
  getHeading(type) {
    const headings = {
      'original': 'language you are learning',
      'translated': 'language you know',
      'additional': 'additional language',
    }
    
    return headings[type]
  }
  
  onClose() {
    this.setState({
      selectionType: 'original',
    })
    
    this.props.onClose()
  }
  
  render() {
    return (
      <View style={[styles.overlay, {display: this.props.show ? 'flex' : 'none'}]}>
        <SelectionOverlay
          show={true}
          ableToClose={this.props.ableToClose}
          onCancel={this.onClose.bind(this)}
          options={this.getOptions(this.state.selectionType)}
          heading={this.getHeading(this.state.selectionType)}
          onSelect={this.onSelect.bind(this, this.state.selectionType)}>
        </SelectionOverlay>
      </View>
    )
  }
}
